import { render, staticRenderFns } from "./CustomerFields.vue?vue&type=template&id=eda704ce&scoped=true"
import script from "./CustomerFields.vue?vue&type=script&lang=js"
export * from "./CustomerFields.vue?vue&type=script&lang=js"
import style0 from "./CustomerFields.vue?vue&type=style&index=0&id=eda704ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda704ce",
  null
  
)

export default component.exports